/**
 * Знак Project OS.
 *
 * Нарисован в разметке, а не подключён картинкой, ради одного свойства:
 * `currentColor`. Знак принимает цвет текста, поэтому в тёмной теме он белый,
 * в светлой — чёрный, и держать две версии файла не нужно. Две версии
 * неизбежно расходятся: правят одну, забывают другую.
 *
 * Он же остаётся резким на любом размере — от 16 пикселей в шапке до
 * страницы входа — и весит меньше запроса за картинкой.
 *
 * Форма: угол из верхней перекладины и правой стойки плюс отдельный квадрат
 * в левом нижнем углу. Сетка 24×24, все грани по целым единицам — знак не
 * размывается на дробных размерах.
 */

import { cn } from '@/lib/utils';

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      focusable="false"
      className={cn('size-6', className)}
    >
      {/* Верхняя перекладина и правая стойка — одной фигурой, без шва. */}
      <path d="M0 0h24v24h-13v-15h-11z" />
      {/* Отдельный квадрат: просвет до угла и снизу, и справа. */}
      <path d="M0 14h9.5v10h-9.5z" />
    </svg>
  );
}

/**
 * Знак вместе с названием.
 *
 * Название — обычный текст, а не контуры: воспроизводить чужую гарнитуру
 * по картинке значит гарантированно ошибиться в начертании, а текст ещё и
 * читается программой чтения с экрана и ищется по странице.
 */
export function BrandLogo({
  className,
  markClassName,
  showName = true,
}: {
  className?: string;
  markClassName?: string;
  showName?: boolean;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <BrandMark className={markClassName} />
      {showName ? (
        <span className="font-medium tracking-tight">
          project <span className="font-semibold">OS</span>
        </span>
      ) : null}
    </span>
  );
}
